export const SET_TEMPLATES = (state, template) => {
  state.templates = template;
};

export const SET_LOADER = (state, payload) => {
  state.loading = payload;
};
